"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userInfoFetched = exports.userConfigFetched = exports.updateUserConfig = exports.updateAccount = exports.submitResetPasswordForm = exports.setUserInfo = exports.setUserConfig = exports.setGoogleQrCode = exports.setAccount = exports.sendResetPasswordEmail = exports.selectAccount = exports.resendVerificationEmail = exports.receiveUserPermissions = exports.receiveBaseNotionalProductInfo = exports.receiveAccount = exports.goToResetPasswordFormStep = exports.goToBaseCurrencyFormStep = exports.getUserPermissions = exports.getUserInfo = exports.getUserConfig = exports.getUserAccounts = exports.getGoogleQrCode = exports.getGoogle2FARecoveryCode = exports.enableYubikey2FA = exports.enable2FA = exports.disable2FA = exports.clearGoogleQrCode = exports.USER_INFO_FETCHED = exports.USER_CONFIG_FETCHED = exports.UPDATE_ACCOUNT = exports.SET_GOOGLE_QRCODE = exports.SET_ACCOUNT = exports.RECEIVE_USER_PERMISSIONS = exports.RECEIVE_KYC = exports.RECEIVE_BASE_NOTIONAL_PRODUCT_INFO = exports.RECEIVE_ACCOUNT = exports.CLEAR_GOOGLE_QRCODE = void 0;
var _apiActions = require("./apiActions");
var _apex = _interopRequireWildcard(require("../../apex"));
var _orderHistoryActions = require("./orderHistoryActions");
var _withdrawActions = require("./withdrawActions");
var _snackbarActions = require("./snackbarActions");
var _modalActions = require("./modalActions");
var _errorTextFormatter = require("../../helpers/errorTextFormatter");
var _kycActions = require("./kycActions");
var _transferActions = require("./transferActions");
var _transferRequestActions = require("./transferRequestActions");
var _affiliateActions = require("../actions/affiliateActions");
var _positionActions = require("./positionActions");
var _depositActions = require("./depositActions");
var _marketStateUpdateActions = require("./marketStateUpdateActions");
var _eotcSettlementActions = require("./eotcSettlementActions");
var _authActions = require("./authActions");
var _loyaltyFeeActions = require("./loyaltyFeeActions");
var _reduxForm = require("redux-form");
var _AccountEventsSubscriptionService = _interopRequireDefault(require("../../services/subscriptions/AccountEventsSubscriptionService"));
var _config = _interopRequireDefault(require("../../config"));
var _userPermissionsContants = require("../../constants/userPermissionsContants");
var _actions = require("../margin/actions");
var _selectors = require("../margin/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var USER_INFO_FETCHED = exports.USER_INFO_FETCHED = 'USER_INFO_FETCHED';
var USER_CONFIG_FETCHED = exports.USER_CONFIG_FETCHED = 'USER_CONFIG_FETCHED';
var RECEIVE_USER_PERMISSIONS = exports.RECEIVE_USER_PERMISSIONS = 'RECEIVE_USER_PERMISSIONS';
var RECEIVE_ACCOUNT = exports.RECEIVE_ACCOUNT = 'RECEIVE_ACCOUNT';
var SET_ACCOUNT = exports.SET_ACCOUNT = 'SET_ACCOUNT';
var RECEIVE_KYC = exports.RECEIVE_KYC = 'RECEIVE_KYC';
var UPDATE_ACCOUNT = exports.UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
var SET_GOOGLE_QRCODE = exports.SET_GOOGLE_QRCODE = 'SET_GOOGLE_QRCODE';
var CLEAR_GOOGLE_QRCODE = exports.CLEAR_GOOGLE_QRCODE = 'CLEAR_GOOGLE_QRCODE';
var RECEIVE_BASE_NOTIONAL_PRODUCT_INFO = exports.RECEIVE_BASE_NOTIONAL_PRODUCT_INFO = 'RECEIVE_BASE_NOTIONAL_PRODUCT_INFO';
var userInfoFetched = exports.userInfoFetched = function userInfoFetched(payload) {
  return {
    type: USER_INFO_FETCHED,
    payload: payload
  };
};
var receiveBaseNotionalProductInfo = exports.receiveBaseNotionalProductInfo = function receiveBaseNotionalProductInfo(payload) {
  return {
    type: RECEIVE_BASE_NOTIONAL_PRODUCT_INFO,
    payload: payload
  };
};
var setUserInfo = exports.setUserInfo = function setUserInfo(payload) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch) {
      var userInfo;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch((0, _apiActions.callAPI)('SetUserInfo', {
              UserName: payload.username,
              Email: payload.email
            }));
          case 2:
            userInfo = _context.sent;
            if (userInfo.result !== false) {
              dispatch(userInfoFetched(userInfo));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'setUserInfoError',
                text: (0, _errorTextFormatter.formatErrorText)(userInfo),
                type: 'warning'
              }));
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var getUserInfo = exports.getUserInfo = function getUserInfo(UserId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(dispatch, getState) {
      var userInfo, OMSsInfo, currentOMSInfo, BaseNotionalProductSymbol, BaseNotionalProductId;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return dispatch((0, _apiActions.callAPI)('GetUserInfo', {
              UserId: UserId
            }))["catch"](function (e) {
              console.error('getUserInfo action error', e);
              return;
            });
          case 2:
            userInfo = _context2.sent;
            _context2.next = 5;
            return dispatch((0, _apiActions.callAPI)('GetOMSs', {
              OperatorId: userInfo.OperatorId
            }))["catch"](function (e) {
              console.error('GetOMS action error', e);
              return;
            });
          case 5:
            OMSsInfo = _context2.sent;
            currentOMSInfo = OMSsInfo.find(function (OMSInfo) {
              return (OMSInfo.Id || OMSInfo.OMSId) === userInfo.OMSId;
            });
            dispatch(userInfoFetched(userInfo));
            dispatch(getUserPermissions(userInfo.UserId));
            dispatch(getUserConfig(userInfo.UserId, userInfo.UserName));
            dispatch(getUserAccounts(userInfo.OMSId)).then(function (accounts) {
              var selectedAccountId = parseInt(localStorage.getItem('selectedAccountId'), 10);
              if (!accounts || accounts.length === 0) {
                console.warn('User has no accounts');
                dispatch(setAccount(null));
                return;
              }
              if (!accounts.some(function (account) {
                return account.AccountId === selectedAccountId;
              })) {
                var _mainAccountSelector;
                selectedAccountId = (_mainAccountSelector = (0, _selectors.mainAccountSelector)(getState())) === null || _mainAccountSelector === void 0 ? void 0 : _mainAccountSelector.AccountId;
              }
              if (selectedAccountId) {
                dispatch(selectAccount(selectedAccountId, userInfo.OMSId));
                dispatch((0, _positionActions.getAccountPositions)(selectedAccountId));
              }
            });
            dispatch((0, _affiliateActions.getAffiliate)(userInfo.OMSId, userInfo.UserId));
            dispatch((0, _loyaltyFeeActions.getOperatorLoyaltyFeeConfigs)(userInfo.OMSId));
            if (currentOMSInfo !== null && currentOMSInfo !== void 0 && currentOMSInfo.BaseNotionalProductSymbol && currentOMSInfo !== null && currentOMSInfo !== void 0 && currentOMSInfo.BaseNotionalProductId) {
              BaseNotionalProductSymbol = currentOMSInfo.BaseNotionalProductSymbol, BaseNotionalProductId = currentOMSInfo.BaseNotionalProductId;
              dispatch(receiveBaseNotionalProductInfo({
                BaseNotionalProductSymbol: BaseNotionalProductSymbol,
                BaseNotionalProductId: BaseNotionalProductId
              }));
            }
            if (currentOMSInfo !== null && currentOMSInfo !== void 0 && currentOMSInfo.SystemMarginEnabled) {
              dispatch((0, _actions.initMarginTrading)(currentOMSInfo.SystemMarginEnabled));
            }
            if (userInfo.MarginBorrowerEnabled) {
              dispatch((0, _actions.getMarginInstruments)(userInfo.OMSId));
            }
            return _context2.abrupt("return", userInfo);
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var userConfigFetched = exports.userConfigFetched = function userConfigFetched(payload) {
  return {
    type: USER_CONFIG_FETCHED,
    payload: payload
  };
};
var getUserConfig = exports.getUserConfig = function getUserConfig(UserId, UserName) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(dispatch) {
      var userConfig;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return dispatch((0, _apiActions.callAPI)('GetUserConfig', {
              UserId: UserId,
              UserName: UserName
            }))["catch"](function (e) {
              console.error('getUserConfig action error', e);
              return;
            });
          case 2:
            userConfig = _context3.sent;
            dispatch(userConfigFetched(userConfig));
            return _context3.abrupt("return", userConfig);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};

/**
 * Merge `config` arg with existing user config
 */
var updateUserConfig = exports.updateUserConfig = function updateUserConfig(config) {
  return function (dispatch, getState) {
    var mergedConfig = _toConsumableArray(getState().user.userConfig);
    config.forEach(function (current) {
      var index = mergedConfig.findIndex(function (i) {
        return i.Key === current.Key;
      });
      if (index !== -1) {
        mergedConfig[index] = current;
      } else {
        mergedConfig.push(current);
      }
    });
    dispatch(userConfigFetched(mergedConfig));
  };
};
var setUserConfig = exports.setUserConfig = function setUserConfig(UserId, UserName, Config) {
  var getUserConfigAfterSetUserConfig = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(dispatch, getState) {
      var _getState, _getState$user, _getState$user2, userInfo, userConfig;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _getState = getState(), _getState$user = _getState.user, _getState$user2 = _getState$user === void 0 ? {} : _getState$user, userInfo = _getState$user2.userInfo;
            _context4.next = 3;
            return dispatch((0, _apiActions.callAPI)('SetUserConfig', {
              UserId: UserId || userInfo.UserId,
              UserName: UserName || userInfo.UserName,
              Config: Config
            }));
          case 3:
            userConfig = _context4.sent;
            if (userConfig.result !== false) {
              if (getUserConfigAfterSetUserConfig) dispatch(getUserConfig(UserId, UserName));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'setUserConfigError',
                text: (0, _errorTextFormatter.formatErrorText)(userConfig),
                type: 'warning'
              }));
            }
            return _context4.abrupt("return", userConfig);
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getUserPermissions = exports.getUserPermissions = function getUserPermissions(UserId) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(dispatch) {
      var permissions, requestPermissions, rolePermissions, roles, permissionRoles, updatedPermissions;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return dispatch((0, _apiActions.callAPI)('GetUserPermissions', {
              UserId: UserId
            }));
          case 2:
            requestPermissions = _context5.sent;
            rolePermissions = new Set(_toConsumableArray(requestPermissions));
            if (!(rolePermissions.has(_userPermissionsContants.userPermissions.operator) || rolePermissions.has(_userPermissionsContants.userPermissions.superUser))) {
              _context5.next = 13;
              break;
            }
            _context5.next = 7;
            return dispatch((0, _apiActions.callAPI)('GetUserRoles', {
              UserId: UserId
            }));
          case 7:
            roles = _context5.sent;
            permissionRoles = roles.flatMap(function (role) {
              return role.Permissions.map(function (permission) {
                return permission;
              });
            });
            updatedPermissions = new Set([].concat(_toConsumableArray(rolePermissions), _toConsumableArray(permissionRoles)));
            permissions = _toConsumableArray(new Set(updatedPermissions));
            _context5.next = 14;
            break;
          case 13:
            permissions = requestPermissions;
          case 14:
            dispatch(receiveUserPermissions(permissions));
          case 15:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function (_x7) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var receiveUserPermissions = exports.receiveUserPermissions = function receiveUserPermissions(payload) {
  return {
    type: RECEIVE_USER_PERMISSIONS,
    payload: payload
  };
};
var isValidAccountId = function isValidAccountId(id) {
  return typeof id === 'number' && id > 0;
};
var getUserAccounts = exports.getUserAccounts = function getUserAccounts(OMSId) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(dispatch) {
      var userAccountIds, accountInfoArray, _iterator, _step, accountId, accountInfo;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return dispatch((0, _apiActions.callAPI)('GetUserAccounts', {
              OMSId: OMSId
            }));
          case 2:
            userAccountIds = _context6.sent;
            accountInfoArray = [];
            _iterator = _createForOfIteratorHelper(userAccountIds);
            _context6.prev = 5;
            _iterator.s();
          case 7:
            if ((_step = _iterator.n()).done) {
              _context6.next = 19;
              break;
            }
            accountId = _step.value;
            if (isValidAccountId(accountId)) {
              _context6.next = 11;
              break;
            }
            return _context6.abrupt("continue", 17);
          case 11:
            _context6.next = 13;
            return dispatch((0, _apiActions.callAPI)('GetAccountInfo', {
              AccountId: accountId,
              OMSId: OMSId
            }));
          case 13:
            accountInfo = _context6.sent;
            dispatch(receiveAccount([accountInfo]));
            // subscribe to events of every user's account
            _apex["default"].connection.subscribeAccountEvents(accountId, OMSId);
            accountInfoArray.push(accountInfo);
          case 17:
            _context6.next = 7;
            break;
          case 19:
            _context6.next = 24;
            break;
          case 21:
            _context6.prev = 21;
            _context6.t0 = _context6["catch"](5);
            _iterator.e(_context6.t0);
          case 24:
            _context6.prev = 24;
            _iterator.f();
            return _context6.finish(24);
          case 27:
            if (!(!Array.isArray(userAccountIds) || userAccountIds.length === 0)) {
              _context6.next = 29;
              break;
            }
            return _context6.abrupt("return", []);
          case 29:
            dispatch((0, _kycActions.subscribeToVerificationLevelUpdateEvents)(accountInfoArray[0]));
            return _context6.abrupt("return", accountInfoArray);
          case 31:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[5, 21, 24, 27]]);
    }));
    return function (_x8) {
      return _ref6.apply(this, arguments);
    };
  }();
};
var updateAccount = exports.updateAccount = function updateAccount(loyaltyProduct) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(dispatch, getState) {
      var _getState$user3, selectedAccountId, accounts, OMSId, currentAccount, payload, Amount, ProductId, response, text;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _getState$user3 = getState().user, selectedAccountId = _getState$user3.selectedAccountId, accounts = _getState$user3.accounts, OMSId = _getState$user3.userInfo.OMSId;
            currentAccount = accounts.find(function (account) {
              return selectedAccountId === account.AccountId;
            });
            payload = _objectSpread(_objectSpread({}, currentAccount), {}, {
              LoyaltyProductId: 0,
              LoyaltyEnabled: false
            });
            if (loyaltyProduct) {
              Amount = loyaltyProduct.Amount, ProductId = loyaltyProduct.ProductId;
              payload.LoyaltyProductId = ProductId;

              // Never enable the loyalty token functionality if the balance is 0.
              if (Amount > 0) {
                payload.LoyaltyEnabled = true;
              }
            }
            _context7.next = 6;
            return dispatch((0, _apiActions.callAPI)('UpdateAccount', payload));
          case 6:
            response = _context7.sent;
            if (response.result) {
              text = loyaltyProduct ? 'Fee token successfully set' : 'Fee token successfully unset';
              dispatch((0, _snackbarActions.showSnack)({
                id: 'UpdateAccountSuccess',
                text: text,
                type: 'success'
              }));
              dispatch(getUserAccounts(OMSId));
            } else {
              dispatch((0, _reduxForm.change)('loyaltyTokenForm', 'loyaltyToken', currentAccount.LoyaltyProductId));
              dispatch((0, _snackbarActions.showSnack)({
                id: 'UpdateAccountError',
                text: (0, _errorTextFormatter.formatErrorText)(response),
                type: 'warning'
              }));
            }
          case 8:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x9, _x10) {
      return _ref7.apply(this, arguments);
    };
  }();
};
var selectAccount = exports.selectAccount = function selectAccount(accountId, OMSId) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8(dispatch, getState) {
      var accounts, account;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            accounts = getState().user.accounts;
            if (!(!Array.isArray(accounts) || accounts.length === 0 || !accountId)) {
              _context8.next = 4;
              break;
            }
            console.warn('No valid account to select.');
            return _context8.abrupt("return");
          case 4:
            account = (accounts || []).find(function (a) {
              return a.AccountId === accountId;
            });
            if (!(accounts.length === 0 || !account)) {
              _context8.next = 9;
              break;
            }
            console.error("No account found with ID ".concat(accountId));
            dispatch(setAccount(0));
            return _context8.abrupt("return");
          case 9:
            dispatch(setAccount(accountId));

            /**
             * 6 is used as default Limit argument due to length of dashboard Recent Activity feed.
             */
            if (_config["default"].global.privateMarketData) {
              dispatch((0, _orderHistoryActions.getOrders)(accountId, OMSId));
            }
            dispatch((0, _withdrawActions.subscribeToWithdrawalTickets)());
            dispatch((0, _orderHistoryActions.subscribeToOrderHistory)());
            dispatch((0, _orderHistoryActions.subscribeToMarginCancelOrderLiquidationEvents)());
            dispatch((0, _transferActions.getTransfers)(accountId));
            dispatch((0, _transferActions.getIncomingTransfers)(OMSId, accountId));
            dispatch((0, _transferRequestActions.getTransferRequestsReceived)(accountId, OMSId));
            dispatch((0, _transferRequestActions.getTransferRequestsRequested)(accountId, OMSId));
            dispatch((0, _marketStateUpdateActions.initMarketTradeSubscription)());
            dispatch((0, _marketStateUpdateActions.subscribeToMarketTradeUpdated)());
            dispatch((0, _eotcSettlementActions.subscribeToAccountSettlements)());
            _AccountEventsSubscriptionService["default"].subscribe(function (update) {
              return dispatch((0, _kycActions.updateAccount)({
                item: update,
                index: getState().user.accounts.findIndex(function (i) {
                  return i.AccountId === accountId;
                })
              }));
            });
            accounts.forEach(function (a) {
              dispatch((0, _positionActions.getAccountPositions)(a.AccountId));
            });
            dispatch((0, _positionActions.subscribeToAccountPositionEvents)());
            dispatch((0, _withdrawActions.getAccountVerificationLevelConfig)());
            dispatch((0, _depositActions.subscribeToDeposits)());
            localStorage.setItem('selectedAccountId', accountId);
            if (account.AccountType === 'Margin') {
              dispatch((0, _actions.preloadMarginData)(accountId, account.OMSID));
            }
          case 28:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x11, _x12) {
      return _ref8.apply(this, arguments);
    };
  }();
};
var receiveAccount = exports.receiveAccount = function receiveAccount(payload) {
  return {
    type: RECEIVE_ACCOUNT,
    payload: payload
  };
};
var setAccount = exports.setAccount = function setAccount(payload) {
  return {
    type: SET_ACCOUNT,
    payload: payload
  };
};
var goToResetPasswordFormStep = exports.goToResetPasswordFormStep = function goToResetPasswordFormStep(step) {
  return function (dispatch) {
    return dispatch((0, _reduxForm.change)('resetPasswordRequest', 'step', step));
  };
};
var goToBaseCurrencyFormStep = exports.goToBaseCurrencyFormStep = function goToBaseCurrencyFormStep(step) {
  return function (dispatch) {
    return dispatch((0, _reduxForm.change)('baseCurrencies', 'step', step));
  };
};
var sendResetPasswordEmail = exports.sendResetPasswordEmail = function sendResetPasswordEmail(UserName) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(dispatch) {
      var response, snackbarPayload;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return dispatch((0, _apiActions.callAPI)('ResetPassword', {
              UserName: UserName
            }));
          case 2:
            response = _context9.sent;
            snackbarPayload = response.result ? {
              id: 'sendResetPasswordEmailSuccess',
              // t('Check Your Email For Reset Password Link');
              text: 'Check Your Email For Reset Password Link',
              type: 'success'
            } : {
              id: 'sendResetPasswordEmailError',
              text: (0, _errorTextFormatter.formatErrorText)(response),
              type: 'warning'
            };
            dispatch((0, _snackbarActions.showSnack)(snackbarPayload));
            setTimeout(function () {
              return dispatch((0, _authActions.logout)());
            }, _config["default"].Snackbar.timeout);
          case 6:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function (_x13) {
      return _ref9.apply(this, arguments);
    };
  }();
};
var submitResetPasswordForm = exports.submitResetPasswordForm = function submitResetPasswordForm() {
  return function (dispatch, getState) {
    var _getState2 = getState(),
      user = _getState2.user;
    dispatch(sendResetPasswordEmail(user.userInfo.UserName));
  };
};
var setGoogleQrCode = exports.setGoogleQrCode = function setGoogleQrCode(payload) {
  return {
    type: SET_GOOGLE_QRCODE,
    payload: payload
  };
};
var clearGoogleQrCode = exports.clearGoogleQrCode = function clearGoogleQrCode() {
  return {
    type: CLEAR_GOOGLE_QRCODE
  };
};
var getGoogleQrCode = exports.getGoogleQrCode = function getGoogleQrCode() {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10(dispatch) {
      var qrCode;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _apex["default"].connection.EnableGoogle2FA();
          case 2:
            qrCode = _context10.sent;
            dispatch(setGoogleQrCode(qrCode));
          case 4:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function (_x14) {
      return _ref10.apply(this, arguments);
    };
  }();
};
var disable2FA = exports.disable2FA = function disable2FA(code) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11(dispatch, getState) {
      var userInfo, auth;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            userInfo = getState().user.userInfo;
            _context11.prev = 1;
            _context11.next = 4;
            return _apex["default"].connection.Disable2FA();
          case 4:
            _context11.next = 6;
            return dispatch((0, _apiActions.callAPI)('Authenticate2FA', {
              Code: code
            }))["catch"](function (e) {
              return console.log(e);
            });
          case 6:
            auth = _context11.sent;
            _context11.next = 13;
            break;
          case 9:
            _context11.prev = 9;
            _context11.t0 = _context11["catch"](1);
            console.error(_context11.t0);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'DISABLE_2FA_ERROR',
              // t('Code Rejected')
              text: 'Code Rejected',
              type: 'warning'
            }));
          case 13:
            if (auth.Authenticated) {
              dispatch(userInfoFetched(_objectSpread(_objectSpread({}, userInfo), {}, {
                Use2FA: false
              })));
              dispatch((0, _modalActions.closeModal)(_modalActions.MODAL_TYPES.DISABLE_2FA));
              dispatch((0, _snackbarActions.showSnack)({
                id: 'DISABLE_2FA_SUCCESS',
                // t('Two Factor Authenticated is disabled')
                text: 'Two-Factor Authenticated is disabled',
                type: 'success'
              }));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'DISABLE_2FA_ERROR',
                // t('Code Rejected')
                text: 'Code Rejected',
                type: 'warning'
              }));
            }
          case 14:
          case "end":
            return _context11.stop();
        }
      }, _callee11, null, [[1, 9]]);
    }));
    return function (_x15, _x16) {
      return _ref11.apply(this, arguments);
    };
  }();
};
var enable2FA = exports.enable2FA = function enable2FA(code) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12(dispatch, getState) {
      var userInfo, auth;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            userInfo = getState().user.userInfo;
            _context12.next = 3;
            return _apex["default"].connection.Authenticate2FA({
              Code: code
            });
          case 3:
            auth = _context12.sent;
            if (auth.Authenticated) {
              dispatch((0, _authActions.authSuccess)(auth));
              dispatch(userInfoFetched(_objectSpread(_objectSpread({}, userInfo), {}, {
                Use2FA: true
              })));
              dispatch((0, _modalActions.closeModal)(_modalActions.MODAL_TYPES.ENABLE_2FA));
              dispatch(clearGoogleQrCode());
              dispatch((0, _snackbarActions.showSnack)({
                id: 'ENABLE_2FA_SUCCESS',
                // t('Two Factor Authenticated is enabled')
                text: 'Two-Factor Authenticated is enabled',
                type: 'success'
              }));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'ENABLE_2FA_ERROR',
                // t('Code Rejected')
                text: 'Code Rejected',
                type: 'warning'
              }));
            }
          case 5:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function (_x17, _x18) {
      return _ref12.apply(this, arguments);
    };
  }();
};
var enableYubikey2FA = exports.enableYubikey2FA = function enableYubikey2FA(otp) {
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13(dispatch, getState) {
      var userInfo, auth;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            userInfo = getState().user.userInfo;
            _context13.next = 3;
            return dispatch((0, _apiActions.callAPI)('EnableYubico2FA', {
              otp: otp
            }));
          case 3:
            auth = _context13.sent;
            if (auth.Enabled2FA) {
              dispatch(userInfoFetched(_objectSpread(_objectSpread({}, userInfo), {}, {
                Use2FA: true
              })));
              dispatch((0, _modalActions.closeModal)(_modalActions.MODAL_TYPES.ENABLE_2FA));
              dispatch(clearGoogleQrCode());
              dispatch((0, _snackbarActions.showSnack)({
                id: 'ENABLE_2FA_SUCCESS',
                // t('Two Factor Authenticated is enabled')
                text: 'Two-Factor Authenticated is enabled',
                type: 'success'
              }));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'ENABLE_2FA_ERROR',
                // t('Code Rejected')
                text: 'Code Rejected',
                type: 'warning'
              }));
            }
          case 5:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return function (_x19, _x20) {
      return _ref13.apply(this, arguments);
    };
  }();
};
var getGoogle2FARecoveryCode = exports.getGoogle2FARecoveryCode = function getGoogle2FARecoveryCode(code) {
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14(dispatch) {
      var response, recoveryCode;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return _apex["default"].connection.RPCPromise('GetGoogle2FARecoveryKey', {
              Code: code
            });
          case 2:
            response = _context14.sent;
            recoveryCode = JSON.parse(response.o);
            if (recoveryCode.Authenticated) {
              dispatch((0, _reduxForm.change)('google2FARecoveryKeyModal', 'recoveryKey', recoveryCode.RecoveryKey));
            } else {
              dispatch((0, _snackbarActions.showSnack)({
                id: 'RECOVERY_ERROR',
                text: recoveryCode.errormsg,
                type: 'warning'
              }));
            }
          case 5:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    return function (_x21) {
      return _ref14.apply(this, arguments);
    };
  }();
};
var resendVerificationEmail = exports.resendVerificationEmail = function resendVerificationEmail(payload) {
  return /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15(dispatch) {
      var Apex, response, snackbarPayload;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            Apex = (0, _apex.getApex)();
            _context15.next = 7;
            break;
          case 4:
            _context15.prev = 4;
            _context15.t0 = _context15["catch"](0);
            return _context15.abrupt("return", dispatch((0, _snackbarActions.showSnack)({
              id: 'apexError',
              text: _context15.t0.message,
              type: 'warning'
            })));
          case 7:
            if (Apex.connection.ResendVerificationEmail) {
              _context15.next = 9;
              break;
            }
            return _context15.abrupt("return", dispatch((0, _snackbarActions.showSnack)({
              id: 'resendVerificationEmailError',
              text: 'Feature Not Available.',
              type: 'warning'
            })));
          case 9:
            _context15.next = 11;
            return Apex.connection.ResendVerificationEmail(payload);
          case 11:
            response = _context15.sent;
            snackbarPayload = response.result ? {
              id: 'resendVerificationEmailSuccess',
              // t('Check Your Email For An Account Verification Email');
              text: 'Check Your Email For An Account Verification Email',
              type: 'success'
            } : {
              id: 'resendVerificationEmailError',
              text: (0, _errorTextFormatter.formatErrorText)(response),
              type: 'warning'
            };
            dispatch((0, _snackbarActions.showSnack)(snackbarPayload));
          case 14:
          case "end":
            return _context15.stop();
        }
      }, _callee15, null, [[0, 4]]);
    }));
    return function (_x22) {
      return _ref15.apply(this, arguments);
    };
  }();
};